import React from "react";
import { graphql } from "gatsby";
import {
  KontentComponentLayout,
  KontentComponentSettings,
} from "../../../types";
import { getMultiChoice } from "../../../lib/multichoice";
import { ArticleListing } from "../../elements/ArticleListing/ArticleListing";
import {
  ArticleListingItems,
  extractCategories,
} from "../../elements/ArticleListing/ArticleListingUtils";

export interface NewsListingProps
  extends KontentComponentSettings,
    KontentComponentLayout,
    ArticleListingItems {}

const NewsListingContainer: React.FC<NewsListingProps> = (props) => {
  const componentWidth = getMultiChoice(
    props.component_layout__component_width
  );

  const categories = extractCategories(props.items);

  return (
    <ArticleListing categories={categories} width={componentWidth} {...props} />
  );
};

export default NewsListingContainer;

export const fragmentNewsListingContainer = graphql`
  fragment NewsListing on kontent_item_news_listing {
    system {
      id
      codename
    }
    internal {
      type
      contentDigest
    }
    elements {
      news {
        value {
          codename
        }
      }
      items
      component_layout__component_width {
        value {
          codename
        }
      }
      component_settings__anchor_name {
        value
      }
      component_settings__hide_on_mobile {
        value {
          codename
        }
      }
    }
  }
`;
